export enum ChannelSort {
    ascending = 'A',
    descending = 'D',
}
